import {LabelInValue} from "../../../../../common/form";
import {Button, List, Skeleton, Typography} from "antd";
import React from "react";
import {useGetTicketTemplateQuery} from "../graphql";
import './list-item.style.less';
import {BASE_CLASS} from "./constants";

export default function ListItem(props: {value: LabelInValue, onRemove: (item: LabelInValue) => void}){

    const { data: ticketTemplate, loading } = useGetTicketTemplateQuery(props.value?.key);

    function renderItemBtns(item: LabelInValue){
        return (
            <Button
                size="small"
                type="danger"
                icon="delete"
                onClick={() => props.onRemove?.(item)}
            />
        )
    }

    let description: React.ReactNode = loading ? <Skeleton paragraph={null} /> : null;

    if (ticketTemplate?.shortDescription){
        description = ticketTemplate.shortDescription;
    }

    let descriptionText = typeof description === 'string' ? description : '';

    let className = `${BASE_CLASS}__list-item-description`;

    return (
        <List.Item extra={renderItemBtns(props.value)}>
            <div>
                <h4>{props.value?.label}</h4>
                <div className={className} title={descriptionText}>
                    <Typography.Text type="secondary">{description}</Typography.Text>
                </div>
            </div>
        </List.Item>
    )
}